<template>
  <ContainerScrolling class="AccessibilityInformation">
    <LayoutFill :no-gutters="!bannerGutter" :no-padding="!bannerGutter">
      <MainBanner :title="pageTitle" :solid-header="solidHeader" />
    </LayoutFill>
    <LayoutGutters>
      <LegalTerms term="ACCESSIBILITY" />
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";
import LayoutFill from "~/components/layout/LayoutFill";

import MainBanner from "~/components/banner/MainBanner";

import LegalTerms from "~/components/page/components/terms/LegalTerms";

import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";

export default {
  name: "AccessibilityInformation",
  components: {
    LegalTerms,
    ContainerScrolling,
    LayoutGutters,
    LayoutFill,
    MainBanner,
  },
  middleware: ["ensureUserLoaded"],
  data() {
    return {
      pageTitle: "Accessibility",
    };
  },
  head() {
    const { siteName } = this;

    const title = getPageTitle(siteName);

    const pageTitle = "Accessibility Information | " + title;

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `We want everyone who visits ${siteName} to find the experience rewarding, read our Accessibility statement for more information.`,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      siteName: (state) => getSiteName(state.theme),
      domain: (state) => state.theme.domain,
      layout: (state) => state.theme.layout,
    }),
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    bannerGutter() {
      return this.layout.staticBannerGuttering;
    },
  },
};
</script>

<style>
.AccessibilityInformation .nudge-left {
  margin-left: -6px;
}
</style>
